// extracted by mini-css-extract-plugin
export default {"main":"Categories_main__UQHx7","mobile":"Categories_mobile__jf9uv","fixed":"Categories_fixed__on4u1","header":"Categories_header__uFXrN"};